import React from 'react'
import '../../layouts/account/account.scss';


export function RequestFeaturePage() {

  return (
    <div className="features-content">
    <iframe src="https://officely.nolt.io/widget?withHeader=false" width="100%" height="100%"></iframe>

    </div>

  )
}



